const getters = {
  token: (state) => state.user.token,
  userinfo: (state) => JSON.parse(state.user.userinfo),
}

export default getters
